export default __webpack_public_path__ + "static/media/logo-1000.c4807026.png";